/* @flow */
import React from 'react';
import { trackPage } from './../../app.js';
import Shop from './container/shop.js';
import Visitors from './container/visitors.js';
import ImpressionsAndViews from './container/impressions-and-views.js';
import Dates from './container/dates.js';

function Container(props) {
  trackPage();
  return (
    <div className="Stats">
      <header>
        <h1>Statistics</h1>
      </header>
      <Dates
        dates={props.dates}
        changeDays={props.changeDays}
        changeCustomDays={props.changeCustomDays}
        parametersChanged={props.parametersChanged}
        location={props.location}
      />
      <Shop {...props}/>
      <Visitors {...props}/>
      <ImpressionsAndViews {...props}/>
    </div>
  );
}

export default Container;



// WEBPACK FOOTER //
// ./src/app/stats/container.js